<template>
  <div />
</template>
<script>
import { paramCase } from 'change-case';
export default {
  name: 'popup-controller',
  model: {
    prop: 'open',
    event: 'close',
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    component: {
      type: String,
      default: '',
    },
    title: String,
    width: {
      type: String,
      default: '600',
    },
    height: {
      type: String,
      default: '400',
    },
    left: {
      type: String,
      default: '200',
    },
    top: {
      type: String,
      default: '200',
    },
  },
  computed: {
    componentParamsName() {
      const paths = this.component.split('/');
      return paths.map((item, index) => (index == paths.length - 1 ? paramCase(item) : item)).join('_');
    },
  },
  data() {
    return {
      popup: null,
    };
  },
  watch: {
    open(active) {
      if (active) this.openWindow();
      else this.closeWindow();
    },
  },
  methods: {
    openWindow() {
      this.popup = window.open(`/popup/${this.componentParamsName}`, '', `width=${this.width},height=${this.height},left=${this.left},top=${this.top}`);
      this.popup.addEventListener('beforeunload', this.beforeunload);
    },
    beforeunload() {
      this.$emit('close');
    },
    closeWindow() {
      if (this.popup) {
        this.popup.close();
        this.popup = null;
      }
    },
  },
  mounted() {
    if (this.open) {
      this.openWindow();
    }
  },
  beforeDestroy() {
    if (this.popup) {
      this.closeWindow();
    }
  },
};
</script>
